import { z } from "zod";

/**
 * Runtime feature flags (PRTL-1353).
 *
 * Stored in the `SiteMeta` table under key "feature-flags" and read through
 * `FeatureFlagService` (@compass/services). Every flag MUST default to
 * `false` so a missing row — or a brand-new flag — is dark until explicitly
 * enabled from the admin Feature Flags page.
 *
 * Flags are temporary: once a feature is enabled globally, remove its gate
 * points and delete the key here.
 */
export const FeatureFlags = z.object({
    /** Compass Calls / meetings hub (PRTL-1299; removal tracked by PRTL-1354). */
    compassCalls: z.boolean().default(false),
    /** Multi-org accounts: login org picker, account switcher, multi-membership admin writes (PRTL-1348). */
    multiOrgAccounts: z.boolean().default(false),
});

export type FeatureFlags = z.infer<typeof FeatureFlags>;

export type FeatureFlagName = keyof FeatureFlags;

/** The parsed defaults — what clients assume while loading (fail closed). */
export const DEFAULT_FEATURE_FLAGS: FeatureFlags = FeatureFlags.parse({});

/** Human-readable metadata for the admin Feature Flags page. */
export const FEATURE_FLAG_INFO: Record<FeatureFlagName, { label: string; description: string }> = {
    compassCalls: {
        label: "Compass Calls",
        description:
            "The /meetings hub, private-event Zoom join flow, My Calls cards, and the meetings section of the private daily digest.",
    },
    multiOrgAccounts: {
        label: "Multi-Org Accounts",
        description:
            "Users can belong to multiple organizations: post-login org picker, in-app account switcher, and multi-membership admin writes. Off: all multi-org UI is hidden and everyone behaves single-org; membership rows are still maintained as the single-org mirror.",
    },
};
